export default __webpack_public_path__ + "static/BAP_3026-Verbessert-NR_rgb_fine-f340fff64af07fbea9056130163efc7a.jpg";